import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoadingService } from '../../shared/loading/loading.service';
import { TranslateService } from '../translation';


export interface IDeactivateComponent {
  canExit: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class FormCheckService implements CanDeactivate<IDeactivateComponent>
{
  component: Object;
  route: ActivatedRouteSnapshot;

  constructor(
    private _loading: LoadingService,
    private _translate: TranslateService
  ){}

  canDeactivate(component:IDeactivateComponent,
              route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot,
              nextState: RouterStateSnapshot) : Observable<boolean> | Promise<boolean> | boolean {

      return component.canExit ? component.canExit() : true;
}

  canExit(form) {
    return true;
  }

}
